/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import { connect } from 'react-redux'

import type { PlatformInfo } from '@modules/cloud-api/v1/types'
import type { AsyncRequestState } from '@modules/ui-types'

import { getPlatformByRegion } from '@/reducers/platform'
import { fetchPlatformRequest } from '@/reducers/asyncRequests/registry'

import { fetchPlatformByRegion } from '../../../actions/platform'
import withPolling from '../../../lib/withPolling'

import Platform from './Platform'

import type { ThunkDispatch, ReduxState } from '@/types/redux'

type StateProps = {
  platform: PlatformInfo | null
  fetchPlatformRequest: AsyncRequestState
}

type DispatchProps = {
  fetchPlatform: () => void
}

type ConsumerProps = {
  regionId: string
}

const mapStateToProps = (state: ReduxState, { regionId }: ConsumerProps): StateProps => ({
  platform: getPlatformByRegion(state, regionId),
  fetchPlatformRequest: fetchPlatformRequest(state, regionId),
})

const mapDispatchToProps = (
  dispatch: ThunkDispatch,
  { regionId }: ConsumerProps,
): DispatchProps => ({
  fetchPlatform: () => dispatch(fetchPlatformByRegion(regionId)),
})

export default connect<StateProps, DispatchProps, ConsumerProps>(
  mapStateToProps,
  mapDispatchToProps,
)(
  withPolling(Platform, ({ fetchPlatform }) => ({
    onPoll: [fetchPlatform],
    pollImmediately: [`regionId`],
  })),
)
